import { cn } from 'ui/utils'

export const ImageAutoinspectorLogo = ({
  className,
}: {
  className?: string
}) => {
  return (
    <img
      className={cn('w-[11rem] h-[1.6rem]', className)}
      src='/assets/images/autoinspector-logo-texto.png'
    />
  )
}
